// src/routes/AdminRoutes.jsx
import MainLayout from 'layout/Dashboard';
import AdminDashboard from 'views/admin/AdminDashboard';
import AdminToolsPage from 'views/admin/AdminToolsPage';
import AdminUsersPage from 'views/admin/AdminUsersPage';
import AdminOrganizationsPage from 'views/admin/AdminOrganizationsPage';
import AdminRolesPage from 'views/admin/AdminRolesPage';
import AdminTeamsPage from 'views/admin/AdminTeamsPage';
import AdminIntegrationsPage from 'views/admin/AdminIntegrationsPage';
import AdminQuotasPage from 'views/admin/AdminQuotasPage';
import AdminBillingPage from 'views/admin/AdminBillingPage';
import AdminSettingsPage from 'views/admin/AdminSettingsPage';
import AdminPoliciesPage from 'views/admin/AdminPoliciesPage';
import AdminConnectorsPage from 'views/admin/AdminConnectorsPage';
import AdminSystemHealthPage from 'views/admin/AdminSystemHealthPage';
import AdminSystemJobsPage from 'views/admin/AdminSystemJobsPage';
import AdminAuditLogsPage from 'views/admin/AdminAuditLogsPage';
import AdminAnnouncementsPage from 'views/admin/AdminAnnouncementsPage';
import AdminSessionsPage from 'views/admin/AdminSessionsPage';
import AdminMaintenancePage from 'views/admin/AdminMaintenancePage';
import AdminArtifactsPage from 'views/admin/AdminArtifactsPage';
import AdminFingerprintsPage from 'views/admin/AdminFingerprintsPage';
import AdminCaseTicketsPage from 'views/admin/AdminCaseTicketsPage';
import AdminCaseEvidencePage from 'views/admin/AdminCaseEvidencePage';
import AdminNotificationRulesPage from 'views/admin/AdminNotificationRulesPage';
import AdminOastSessionsPage from 'views/admin/AdminOastSessionsPage';
import AdminVexStatementsPage from 'views/admin/AdminVexStatementsPage';
import AdminSlaPolicyPage from 'views/admin/AdminSlaPolicyPage';
import AdminCaseAutomationPage from 'views/admin/AdminCaseAutomationPage';
import AdminSigmaRulesPage from 'views/admin/AdminSigmaRulesPage';
import AdminPolicyGatesPage from 'views/admin/AdminPolicyGatesPage';
import AdminIdentityConfigPage from 'views/admin/AdminIdentityConfigPage';
import AdminObservabilityPage from 'views/admin/AdminObservabilityPage';
import AdminNucleiTemplatesPage from 'views/admin/AdminNucleiTemplatesPage';
import AdminThreatAlertsPage from 'views/admin/AdminThreatAlertsPage';

const AdminRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/admin',
      element: <AdminDashboard />
    },
    {
      path: '/admin/tools',
      element: <AdminToolsPage />
    },
    {
      path: '/admin/users',
      element: <AdminUsersPage />
    },
    {
      path: '/admin/organizations',
      element: <AdminOrganizationsPage />
    },
    {
      path: '/admin/roles',
      element: <AdminRolesPage />
    },
    {
      path: '/admin/teams',
      element: <AdminTeamsPage />
    },
    {
      path: '/admin/integrations',
      element: <AdminIntegrationsPage />
    },
    {
      path: '/admin/quotas',
      element: <AdminQuotasPage />
    },
    {
      path: '/admin/billing',
      element: <AdminBillingPage />
    },
    {
      path: '/admin/settings',
      element: <AdminSettingsPage />
    },
    {
      path: '/admin/policies',
      element: <AdminPoliciesPage />
    },
    {
      path: '/admin/sigma-rules',
      element: <AdminSigmaRulesPage />
    },
    {
      path: '/admin/policy-gates',
      element: <AdminPolicyGatesPage />
    },
    {
      path: '/admin/identity-config',
      element: <AdminIdentityConfigPage />
    },
    {
      path: '/admin/observability',
      element: <AdminObservabilityPage />
    },
    {
      path: '/admin/connectors',
      element: <AdminConnectorsPage />
    },
    {
      path: '/admin/threat-alerts',
      element: <AdminThreatAlertsPage />
    },
    {
      path: '/admin/nuclei-templates',
      element: <AdminNucleiTemplatesPage />
    },
    {
      path: '/admin/system/health',
      element: <AdminSystemHealthPage />
    },
    {
      path: '/admin/system/jobs',
      element: <AdminSystemJobsPage />
    },
    {
      path: '/admin/audit-logs',
      element: <AdminAuditLogsPage />
    },
    {
      path: '/admin/announcements',
      element: <AdminAnnouncementsPage />
    },
    {
      path: '/admin/system/sessions',
      element: <AdminSessionsPage />
    },
    {
      path: '/admin/system/maintenance',
      element: <AdminMaintenancePage />
    },
    {
      path: '/admin/artifacts',
      element: <AdminArtifactsPage />
    },
    {
      path: '/admin/fingerprints',
      element: <AdminFingerprintsPage />
    },
    {
      path: '/admin/case-tickets',
      element: <AdminCaseTicketsPage />
    },
    {
      path: '/admin/case-evidence',
      element: <AdminCaseEvidencePage />
    },
    {
      path: '/admin/notification-rules',
      element: <AdminNotificationRulesPage />
    },
    {
      path: '/admin/sla-policy',
      element: <AdminSlaPolicyPage />
    },
    {
      path: '/admin/case-automation',
      element: <AdminCaseAutomationPage />
    },
    {
      path: '/admin/vex-statements',
      element: <AdminVexStatementsPage />
    },
    {
      path: '/admin/oast-sessions',
      element: <AdminOastSessionsPage />
    }
  ]
};

export default AdminRoutes;
